module.exports = __webpack_public_path__ + "3eba9def0d1871b9d533c8fb410d4f5d.svg";